import { rem } from 'polished';
import styled from 'styled-components';

export const StyledHeader = styled.header`
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  height: ${rem('83px')};
  z-index: ${({ theme }) => theme.layers.header};
  background-color: ${({ theme }) => theme.colors.main};
`;

export const StyledLabel = styled.span`
  display: none;
  margin-right: ${({ theme }) => rem(theme.spacings.s)};
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 700;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    display: inline;
  }
`;

export const StyledLogoWrapper = styled.div`
  width: ${rem('110px')};
`;
